import { render, staticRenderFns } from "./PreTestSubmissions.vue?vue&type=template&id=9b0ac052&scoped=true"
import script from "./PreTestSubmissions.vue?vue&type=script&lang=js"
export * from "./PreTestSubmissions.vue?vue&type=script&lang=js"
import style0 from "./PreTestSubmissions.vue?vue&type=style&index=0&id=9b0ac052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0ac052",
  null
  
)

export default component.exports